import { GetterTree } from 'vuex'
import State from './types'
import { RootState } from '../types'

export const getters: GetterTree<State, RootState> = {
  salesRep({ activeSalesRep: salesRep }) {
    return salesRep
  },
  salesRepLoading({ loading }) {
    return loading
  },
  errorMessage({ error, errorMessage }) {
    return error ? errorMessage : ''
  },
}
